module.exports = __webpack_public_path__ + "static/media/header_full_pizzeria.0278f34e.svg";